import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { TransferToErCommand } from './transfer-to-er.command';

/**
 * TransferToEr use case.
 * Transfers a case to Employee Relations (ER) with closing notes.
 * This action closes the case in Case Management and transfers ownership to ER team.
 */
@Injectable({ providedIn: 'root' })
export class TransferToErUseCase {
  private readonly _repository = inject(CasesRepository);

  /**
   * Executes the transfer to ER operation.
   * @param command - Transfer command with case ID and closing notes
   * @returns Observable void (completes on success)
   */
  public execute(command: TransferToErCommand): Observable<void> {
    return this._repository.transferToEr(command.caseId, command.closingNotes);
  }
}
